(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Motion: 3D scroll experience. Skipped entirely for reduced motion.
  // ------------------------------------------------------------------
  window.__osMotion = true;
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { doc.classList.remove('js-motion'); return; }
  doc.classList.add('js-motion');

  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var header = document.querySelector('.site-header');
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var REVEAL = '.section-head, .dept, .product-card, .camp, .newsletter__inner, .circles > li, .ahead, .ccard, .pcard, .bento__tile, [data-reveal]';
  var tracked = [];
  var visible = new Set();

  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var t = e.target;
        t.classList.add('is-in');
        revealIO.unobserve(t);
        setTimeout(function () { t.classList.add('is-done'); }, 1200 + (parseInt(t.style.getPropertyValue('--d'), 10) || 0));
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  var viewIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
    requestTick();
  }, { rootMargin: '20% 0px' });

  function scan(scope) {
    scope = scope || document;
    scope.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.dataset.osReveal) return;
      el.dataset.osReveal = '1';
      var i = Array.prototype.indexOf.call(el.parentNode.children, el) % 6;
      el.style.setProperty('--d', (i * 90) + 'ms');
      revealIO.observe(el);
    });
    scope.querySelectorAll('.hero, .ahero, .camp, .dept, .statement').forEach(function (el) {
      if (el.dataset.osScroll) return;
      el.dataset.osScroll = el.classList.contains('hero') ? 'hero' : el.classList.contains('ahero') ? 'ahero' : el.classList.contains('statement') ? 'pin' : 'item';
      tracked.push(el);
      viewIO.observe(el);
    });
    scope.querySelectorAll('[data-split]').forEach(function (el) {
      if (el.dataset.osSplit) return;
      el.dataset.osSplit = '1';
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      el.style.setProperty('--n', words.length);
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.textContent = w;
        s.style.setProperty('--i', i);
        el.appendChild(s);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
    if (fine) scope.querySelectorAll('.dept, .product-card, .bento__tile').forEach(bindTilt);
    if (fine) scope.querySelectorAll('.hero').forEach(bindHero);
  }

  function bindTilt(el) {
    if (el.dataset.osTilt) return;
    el.dataset.osTilt = '1';
    var max = el.classList.contains('dept') ? 7 : 9;
    el.addEventListener('pointermove', function (e) {
      if (!el.classList.contains('is-in')) return;
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.classList.add('is-tilting');
      el.style.setProperty('--ry', ((x - 0.5) * max * 2).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((0.5 - y) * max * 2).toFixed(2) + 'deg');
      el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    });
    el.addEventListener('pointerleave', function () {
      el.classList.remove('is-tilting');
      el.style.removeProperty('--rx');
      el.style.removeProperty('--ry');
    });
  }

  function bindHero(hero) {
    if (hero.dataset.osHero) return;
    hero.dataset.osHero = '1';
    var art = hero.querySelector('.hero__art');
    if (!art) return;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      art.style.setProperty('--mx', (((e.clientX - r.left) / r.width) - 0.5).toFixed(3));
      art.style.setProperty('--my', (((e.clientY - r.top) / r.height) - 0.5).toFixed(3));
    });
    hero.addEventListener('pointerleave', function () { art.style.setProperty('--mx', 0); art.style.setProperty('--my', 0); });
  }

  var ticking = false;
  function requestTick() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var max = doc.scrollHeight - vh;
    bar.style.setProperty('--sp', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
    visible.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var mode = el.dataset.osScroll;
      if (mode === 'hero') {
        var hp = clamp(-r.top / r.height, 0, 1).toFixed(4);
        el.style.setProperty('--hp', hp);
        var art = el.querySelector('.hero__art');
        if (art) art.style.setProperty('--hp', hp);
      } else if (mode === 'ahero') {
        var f = el.querySelector('.ahero__frame');
        if (f) el.style.setProperty('--e', clamp(1 - (f.getBoundingClientRect().top - vh * 0.12) / (vh * 0.55), 0, 1).toFixed(4));
      } else if (mode === 'pin') {
        var p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
        el.style.setProperty('--e', clamp(p * 1.9, 0, 1).toFixed(4));
        el.style.setProperty('--t', clamp((p - 0.35) / 0.6, 0, 1).toFixed(4));
      } else {
        el.style.setProperty('--p', clamp((vh - r.top) / (vh + r.height), 0, 1).toFixed(4));
      }
    });
  }

  scan();
  update();
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); requestTick(); });
})();
